import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Sidebar from "./Sidebar";
import "../styles/dashboard.css";

const carData = {
    "Maruti Suzuki": ["Swift", "Baleno", "Brezza", "Ertiga", "Dzire", "Alto K10", "Grand Vitara", "Jimny"],
    "Hyundai": ["Creta", "Venue", "Verna", "i20", "i10 Nios", "Alcazar", "Tucson", "Exter"],
    "Tata Motors": ["Nexon", "Punch", "Harrier", "Safari", "Tiago", "Tigor", "Altroz"],
    "Mahindra": ["Scorpio-N", "XUV700", "Thar", "XUV300", "Bolero", "Scorpio Classic"],
    "Toyota": ["Innova Hycross", "Fortuner", "Glanza", "Urban Cruiser Hyryder", "Hilux", "Camry"],
    "Kia": ["Seltos", "Sonet", "Carens", "EV6"],
    "Honda": ["City", "Amaze", "Elevate"],
    "Skoda": ["Kushaq", "Slavia", "Kodiaq"],
    "Volkswagen": ["Virtus", "Taigun", "Tiguan"],
    "MG": ["Hector", "Astor", "ZS EV", "Comet EV"]
};

export default function Dashboard() {
    const navigate = useNavigate();
    const [selectedBrand, setSelectedBrand] = useState("");
    const [selectedModel, setSelectedModel] = useState("");
    const [vehicles, setVehicles] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [stats, setStats] = useState({ totalVehicles: 0, totalParts: 0, todaySale: 0 });

    const token = localStorage.getItem("token");
    const config = { headers: { Authorization: `Bearer ${token}` } };

    // --- 1. Fetch Stats & Vehicles (Real-time update logic) ---
    const fetchData = async () => {
    try {
        const token = localStorage.getItem("token");
        const config = { headers: { Authorization: `Bearer ${token}` } };
        
        // Ek saath saara data fetch karo
        const [statsRes, vehRes] = await Promise.all([

            //  live api

            axios.get("https://bhopalbackend.nileshdawande.in/api/stats/dashboard-stats", config),
            axios.get("https://bhopalbackend.nileshdawande.in/api/stats/vehicles", config)

            // local api

            // axios.get("http://localhost:5000/api/stats/dashboard-stats", config),
            // axios.get("http://localhost:5000/api/stats/vehicles", config)


            
        ]);
        
        setStats(statsRes.data); // Boxes update honge (image_ab3e67.png niche wala part)
        setVehicles(vehRes.data); // Table update hogi
    } catch (err) {
        console.error("Data fetch error", err);
    }
};

    useEffect(() => { fetchData(); }, []);

    // --- 2. CREATE Vehicle (Real-time save) ---
    const handleAddVehicle = async (e) => {
        e.preventDefault();
        if (!selectedBrand || !selectedModel) return Swal.fire("Error", "Select Brand & Model", "error");

        try {

            // real live api

            await axios.post("https://bhopalbackend.nileshdawande.in/api/stats/select-vehicle", { 
                brand: selectedBrand, 
                model: selectedModel 
            }, config);

            // local api

            // await axios.post("http://localhost:5000/api/stats/select-vehicle", { 
            //     brand: selectedBrand, 
            //     model: selectedModel 
            // }, config);
            
            Swal.fire({ icon: 'success', title: 'Vehicle Added', timer: 1000, showConfirmButton: false });
            fetchData(); // Stats aur Table update karne ke liye
            setSelectedBrand(""); setSelectedModel("");
        } catch (err) {
            Swal.fire("Error", "Could not add vehicle", "error");
        }
    };

    // --- 3. DELETE Vehicle ---
const deleteVehicle = async (id) => {
        // Fix: Swal ko hamesha upar dikhane ke liye logic
        const confirm = await Swal.fire({
            title: 'Delete Karein?',
            text: "Kya aap is vehicle ko hatana chahte hain?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ef4444',
            cancelButtonColor: '#334155',
            confirmButtonText: 'Haan, Delete!',
            background: '#0f172a',
            color: '#fff',
            // Ye line confirm message ko table ke upar layegi
            target: document.querySelector('.modal-backdrop-custom') 
        });

        if (confirm.isConfirmed) {
            try {
                const token = localStorage.getItem("token");

                // real live api

                await axios.delete(`https://bhopalbackend.nileshdawande.in/api/stats/vehicle/${id}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });

               // local api
            
                // await axios.delete(`http://localhost:5000/api/stats/vehicle/${id}`, {
                //     headers: { Authorization: `Bearer ${token}` }
                // });

                fetchData(); // Refresh list
                Swal.fire({
                    title: 'Deleted!',
                    icon: 'success',
                    target: document.querySelector('.modal-backdrop-custom')
                });
            } catch (err) {
                console.error("Delete failed", err);
            }
        }
    };

    return (
        <div className="dashboard">
            <Sidebar />
            <div className="content-area">
                <div className="welcome-header">
                    <h2 className="animate-text">Bhopal Seat Cover Dashboard</h2>
                    <p className="lead">Manage inventory and real-time sales statistics.</p>
                </div>


                {/* Vehicle Selection & Add Form */}
                <div className="service-form-card mt-4">
                    <h4 className="form-title">Select & Add Vehicle</h4>
                    <form onSubmit={handleAddVehicle} className="car-selection-form">
                        <div className="form-row">
                            <div className="input-group">
                                <label>CAR BRAND</label>
                                <input 
                                    list="brandList" className="form-input" placeholder="Select Brand..."
                                    value={selectedBrand} onChange={(e) => { setSelectedBrand(e.target.value); setSelectedModel(""); }}
                                />
                                <datalist id="brandList">
                                    {Object.keys(carData).map(b => <option key={b} value={b} />)}
                                </datalist>
                            </div>
                            <div className="input-group">
                                <label>CAR MODEL</label>
                                <input 
                                    list="modelList" className="form-input" placeholder="Select Model..."
                                    value={selectedModel} onChange={(e) => setSelectedModel(e.target.value)}
                                    disabled={!selectedBrand}
                                />
                                    <datalist id="modelList">
                                    {selectedBrand && carData[selectedBrand]?.map((model) => (
                                    <option key={model} value={model} />
                                    ))}
                                    </datalist>
                            </div>
                        </div>
                        <div className="d-flex gap-2 mt-3">
                            <button type="submit" className="btn-submit flex-grow-1">ADD VEHICLE</button>
                            <button type="button" className="btn-check-list" onClick={() => setShowModal(true)}>
                                <i className="fas fa-list"></i> CHECK LIST
                            </button>
                        </div>
                    </form>
                </div>

                
                {/* Stats Section - Updated Real Time */}
                <div className="stats-grid">
                    <div className="card-stat">
                        Total Vehicles <span>{stats.totalVehicles}</span>
                    </div>
                    <div className="card-stat">
                        Total Parts <span>{stats.totalParts}</span>
                    </div>
                    <div className="card-stat">
                        Today Sale <span>₹{stats.todaySale.toLocaleString()}</span>
                    </div>
                </div>

                {/* --- CRUD MODAL (Table) --- */}

                


                {showModal && (
                    <div className="modal-backdrop-custom">
                        <div className="modal-card animate-fade-in">
                        
                        <div className="modal-header-custom">
                            <h4>Vehicle List Management</h4>
                            <button
                            className="btn-close-custom"
                            onClick={() => setShowModal(false)}
                            >
                            ✕
                            </button>
                        </div>

                        <div className="table-wrapper">
                            <table className="custom-table">
                            <thead>
                                <tr>
                                <th>Brand</th>
                                <th>Model</th>
                                <th>Date</th>
                                <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {vehicles.map((v) => (
                                <tr key={v._id}>
                                    <td>{v.brand}</td>
                                    <td>{v.model}</td>
                                    <td>{new Date(v.createdAt).toLocaleDateString()}</td>
                                     <td>
                                        {/* <button className="btn-action-view" onClick={() => navigate("/stock-management")}>Stock</button> */}
                                        
                                        <button
                                        className="btn-action-view"
                                        onClick={() =>
                                            navigate(
                                            `/vehicle-stock?brand=${encodeURIComponent(v.brand)}&model=${encodeURIComponent(v.model)}`
                                            )
                                        }
                                        >
                                        Stock
                                        </button>

                                        <button className="btn-action-del" onClick={() => deleteVehicle(v._id)}>Delete</button>
                                    </td>
                                </tr>
                                ))}
                            </tbody>
                            </table>
                        </div>

                        </div>
                    </div>
            )}


            </div>
        </div>
    );
}
             
